import {ActionButtonRow, HeadlineH1} from 'arkulpa-fec';
import gql from 'graphql-tag';
import {FlatButton, TextField} from 'material-ui';
import PropTypes from 'prop-types';
import React, {Component} from 'react';
import {graphql, Mutation} from 'react-apollo';
import {withRouter} from 'react-router';
import {HalfWidth, TwoColContent} from './UserForm';

const MOVMENT_SETTINGS = gql`
  query movementSettings {
    movementSettings {
      x1
      x2
      t1
      t2
    }
  }
`;
const SAVE_MOVEMENT_SETTINGS = gql`
  mutation saveMovementSettings($input: MovementSettingsInput) {
    saveMovementSettings(input: $input) {
      x1
      x2
      t1
      t2
    }
  }
`;
class MovementSettings extends Component {
  constructor(props) {
    super(props);
    if (props.data.movementSettings) {
      this.state = props.data.movementSettings;
    } else {
      this.state = {
        x1: 0,
        x2: 0,
        t1: 0,
        t2: 0,
      };
    }
  }
  componentWillReceiveProps = (newProps) => {
    if (newProps.data && newProps.data.movementSettings) {
      const {movementSettings} = newProps.data || {};
      this.setState({...movementSettings});
      console.log('movementSettings', movementSettings);
    }
  };
  render() {
    return (
      <div>
        <HeadlineH1>Movement settings</HeadlineH1>
        <Mutation mutation={SAVE_MOVEMENT_SETTINGS}>
          {(saveMovementSettings, {data}) => {
            return (
              <div>
                <TwoColContent>
                  <HalfWidth>
                    <TextField
                      type='number'
                      fullWidth={true}
                      floatingLabelText='x1'
                      value={this.state.x1}
                      onChange={({target: {value}}) => this.setState({x1: parseInt(value, 10)})}
                    />
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <TextField
                      type='number'
                      fullWidth={true}
                      floatingLabelText='x2'
                      value={this.state.x2}
                      onChange={({target: {value}}) => this.setState({x2: parseInt(value, 10)})}
                    />
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <TextField
                      type='number'
                      fullWidth={true}
                      floatingLabelText='t1 (min 1, max 3)'
                      value={this.state.t1}
                      onChange={({target: {value}}) => {
                        const v = parseInt(value, 10);
                        if (v > 0 && v <= 3) this.setState({t1: v});
                      }}
                    />
                  </HalfWidth>
                </TwoColContent>
                <TwoColContent>
                  <HalfWidth>
                    <TextField
                      type='number'
                      fullWidth={true}
                      floatingLabelText='t2 (min 1, max 3)'
                      value={this.state.t2}
                      onChange={({target: {value}}) => {
                        const v = parseInt(value, 10);
                        if (v > 0 && v <= 3) this.setState({t2: v});
                      }}
                    />
                  </HalfWidth>
                </TwoColContent>
                <ActionButtonRow>
                  <FlatButton onClick={() => this.props.history.push('/devices')} label='Back to list' />
                  <FlatButton
                    onClick={(event) => {
                      const {__typename, ...input} = this.state;
                      saveMovementSettings({variables: {input}})
                        .then(() => {
                          this.props.history.push('/devices');
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }}
                    label='save'
                  />
                </ActionButtonRow>
              </div>
            );
          }}
        </Mutation>
      </div>
    );
  }
  static propTypes = {
    history: PropTypes.object.isRequired,
  };
}
export default withRouter(graphql(MOVMENT_SETTINGS)(MovementSettings));



// WEBPACK FOOTER //
// ./src/components/MovementSettings.js